import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/passage/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/passage/detail', Object.assign({}, options, { params }));

export const beforeDelete = (params, options) =>
  request.post('/api/park/passage/beforeDelete', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/park/passage/remove', qs.stringify(params), options);

export const openOrClose = (params, options) =>
  request.post('/api/park/passage/operate', params, options);

export const grepImage = (params, options) =>
  request.post('/api/park/passage/grepImage', params, options);

export const add = (params, options) => request.post('/api/park/passage/save', params, options);

export const update = (params, options) =>
  request.post('/api/park/passage/update', params, options);

export const passageSelections = (params, options) =>
  request.post('/api/park/passage/selections', qs.stringify(params), options);

export const passageList = (params, options) =>
  request.post('/api/park/sentrybox/passage/passageList', qs.stringify(params), options);
